<template>
    <div class="uk-padding uk-background-muted" style="min-height: 75vh">
        <div class="uk-container uk-container-small">
            <h1 class="uk-text-center">Help & Resources</h1><br>
            <h3 class="uk-heading-line"><span>Aeorion Account</span></h3>
            <div class="uk-child-width-1-2@m" uk-grid>
                <div>
                    <ul class="uk-list uk-list-divider">
                        <li>
                            <iframe width="100%" height="216"
                                    src="https://www.youtube.com/embed/NjUasmPuNMI"
                                    frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            <br>

                            <a href="#" target="_blank">Account Activation</a>
                            <br>
                        </li>
                    </ul>
                </div>
                <div>
                    <ul class="uk-list uk-list-divider">
                        <li>
                            <iframe width="100%" height="216"
                                    src="https://www.youtube.com/embed/55Q0C0woHJE"
                                    frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            <br>
                            <a href="#" target="_blank">Modify Account Information</a>
                            <br>
                        </li>
                    </ul>
                </div>
            </div>
            <h3 class="uk-heading-line"><span>Finance</span></h3>
            <div class="uk-child-width-1-2@m" uk-grid>
                <div>

                    <ul class="uk-list uk-list-divider">
                        <li>
                            <iframe width="100%" height="216"
                                    src="https://www.youtube.com/embed/hCzvlNVJpAw"
                                    frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            <br>
                            <a href="#" target="_blank">Check Account Balance</a>
                            <br>
                        </li>
                        <li>
                            <iframe width="100%" height="216"
                                    src="https://www.youtube.com/embed/C6uMfrrvuGs"
                                    frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            <br>
                            <a href="#" target="_blank">Cheque Requisition</a>
                            <br>
                        </li>

                    </ul>
                </div>
                <div>
                    <ul class="uk-list uk-list-divider">
                        <li>
                            <iframe width="100%" height="216"
                                    src="https://www.youtube.com/embed/yM4peoXxS8I"
                                    frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            <br>
                            <a href="#" target="_blank">Exam Permit</a>
                            <br>
                        </li>
                    </ul>
                </div>
            </div>
            <h3 class="uk-heading-line"><span>Registration</span></h3>
            <div class="uk-child-width-1-2@m" uk-grid>
                <div>
                    <ul class="uk-list uk-list-divider">
                        <li>
                            <iframe width="100%" height="216"
                                    src="https://www.youtube.com/embed/wiII-G0xUR8"
                                    frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            <br>

                            <a href="#" target="_blank">Class Registration</a>
                            <br>
                        </li>
                    </ul>
                </div>
                <div>
                    <ul class="uk-list uk-list-divider">
                        <li>

                            <br>
                        </li>
                    </ul>
                </div>
            </div>
            <h3 class="uk-heading-line"><span>Graduation</span></h3>
            <div class="uk-child-width-1-2@m" uk-grid>
                <div>
                    <ul class="uk-list uk-list-divider">
                        <li>
                            <iframe width="100%" height="216"
                                    src="https://www.youtube.com/embed/6m_46VczjII"
                                    frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            <br>

                            <a href="#" target="_blank">Apply for Graduation</a>
                            <br>
                        </li>
                    </ul>
                </div>
                <div>
                    <ul class="uk-list uk-list-divider">
                        <li>

                            <br>
                        </li>
                    </ul>
                </div>
            </div>
            <h3 class="uk-heading-line"><span>Learning Management</span></h3>
            <div class="uk-child-width-1-2@m" uk-grid>
                <div>
                    <ul class="uk-list uk-list-divider">
                        <li>
                            <iframe width="100%" height="216"
                                    src="https://www.youtube.com/embed/hS8u9kkdE6s"
                                    frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

                            <a href="#" target="_blank">Uploading an Assignment</a>
                            <br>
                        </li>
                    </ul>
                </div>
                <div>
                    <ul class="uk-list uk-list-divider">
                        <li>
                            <iframe width="100%" height="216"
                                    src="https://www.youtube.com/embed/AepUWDs4Izo"
                                    frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            <a href="#" target="_blank">Live Session Archives</a>
                            <br>
                        </li>
                    </ul>
                </div>
            </div>
            <h3 class="uk-heading-line"><span>Student Records</span></h3>
            <div class="uk-child-width-1-2@m" uk-grid>
                <div>
                    <ul class="uk-list uk-list-divider">
                        <li>
                            <iframe width="100%" height="216"
                                    src="https://www.youtube.com/embed/YsAwvqJliVE"
                                    frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

                            <a href="#" target="_blank">All Grades / Unofficial Transcript</a>
                            <br>
                        </li>
                    </ul>
                </div>
                <div>
                    <ul class="uk-list uk-list-divider">

                    </ul>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "helpvideos"
    }
</script>

<style scoped>
    li{
        padding-top: 15px !important;
        padding-bottom: 15px !important;
    }
</style>